var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Box, Center, FormControl, FormErrorMessage, FormLabel, Input, Text } from '@chakra-ui/react';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { ScaleLoader } from 'react-spinners';
import { BaseDialog, BaseDialogState } from '@/app/UIComponents/BaseDialog';
import { emailStringVerify } from '@@/Util';
export class LetrLinkEmailDialogState {
    constructor() {
        this.dialogstate = new BaseDialogState();
        this.creating = false;
        this.name = "";
        this.email = "";
        this.id = "";
        this.errormessage = "";
        makeObservable(this);
        this.dialogstate.setOkLabel("Send");
        this.dialogstate.setHeaderLabel("Email");
        this.dialogstate.onOk = () => {
            var _a;
            if (!this.name.trim() || !emailStringVerify(this.email)) {
                this.setErrorMessage("Please enter valid name and email");
            }
            else {
                this.setErrorMessage("");
                this.setCreating(true);
                (_a = this.sendEmail) === null || _a === void 0 ? void 0 : _a.call(this, this.name, this.email, this.id);
            }
        };
    }
    setErrorMessage(msg) {
        this.errormessage = msg;
    }
    setCreating(cre) {
        this.creating = cre;
    }
    setEmail(email) {
        this.email = email;
    }
    setName(name) {
        this.name = name;
    }
    setOpen(open) {
        this.dialogstate.setOpen(open);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrLinkEmailDialogState.prototype, "creating", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrLinkEmailDialogState.prototype, "name", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrLinkEmailDialogState.prototype, "email", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrLinkEmailDialogState.prototype, "errormessage", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrLinkEmailDialogState.prototype, "setErrorMessage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrLinkEmailDialogState.prototype, "setCreating", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrLinkEmailDialogState.prototype, "setEmail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrLinkEmailDialogState.prototype, "setName", null);
let LetrLinksEmailDialog = class LetrLinksEmailDialog extends React.Component {
    constructor(prop) {
        super(prop);
    }
    buildDialogBody() {
        return React.createElement(Box, null,
            React.createElement(FormControl, { id: "name" },
                React.createElement(FormLabel, null, "Name"),
                React.createElement(Input, { value: this.props.state.name, onChange: (e) => this.props.state.setName(e.currentTarget.value), type: "text" }),
                React.createElement(FormErrorMessage, null)),
            React.createElement(FormControl, { id: "Email" },
                React.createElement(FormLabel, null, "Email"),
                React.createElement(Input, { value: this.props.state.email, onChange: (e) => this.props.state.setEmail(e.currentTarget.value), type: "email" }),
                React.createElement(FormErrorMessage, null)),
            React.createElement(Box, { h: '40px', mt: '10px' },
                this.props.state.creating && React.createElement(Center, { w: '100%' },
                    React.createElement(ScaleLoader, { color: 'green' })),
                this.props.state.errormessage && React.createElement(Center, { w: '100%' },
                    React.createElement(Text, { color: 'red' }, this.props.state.errormessage))));
    }
    render() {
        return (React.createElement(Box, null,
            React.createElement(BaseDialog, { state: this.props.state.dialogstate, body: this.buildDialogBody() })));
    }
};
LetrLinksEmailDialog = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], LetrLinksEmailDialog);
export { LetrLinksEmailDialog };
